import * as React from 'react';

import Breadcrumbs from 'src/components/common/Breadcrumbs';
import Lists from 'src/components/Lists';

import './ListsView.scss';
import i18n from 'src/translation/i18n';
import env from 'src/shared/env';

class ListsView extends React.Component {
  public render() {
    return (
      <div className="rp-lists-view">
        <Breadcrumbs>
          {i18n.t('common.home')} /{' '}
          {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? i18n.t('myFavourites.breadCrumbCA')
            : i18n.t('myFavourites.breadCrumb')}{' '}
        </Breadcrumbs>
        <div className="rp-lists--title">
          {i18n.t('myFavourites.myLists')} /{' '}
          {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? i18n.t('myFavourites.favouritesCA')
            : i18n.t('myFavourites.favourites')}
        </div>
        <Lists />
      </div>
    );
  }
}

export default ListsView;
